"use client";

import { useUser } from "hooks/useUser";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { getSafePostLoginPath, getStoredAuthUser } from "utils/authRoutes";

export default function PublicGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { verifyUser, authUser } = useUser();
  const router = useRouter();
  const searchParams = useSearchParams();
  const redirectTo = verifyUser();

  useEffect(() => {
    if (redirectTo === "feed") {
      router.replace(
        getSafePostLoginPath(
          searchParams.get("redirect"),
          authUser ?? getStoredAuthUser(),
        ),
      );
    }
  }, [redirectTo, authUser, router, searchParams]);

  if (redirectTo === "feed") {
    return null;
  }

  return children;
}
